const Config = {
	MAX_WIDTH_COLUMN: 218,
	MAX_PER_COLUMN: 5,
	MAX_POINTS: 10,
	CARET_SIZE: 8,
	TRANSLATE_PERCENT: {
		// Amount to move the tooltip to the left or right depending on proximity to the edge of the chart
		DEFAULT: 50,
		RIGHT: 80,
		LEFT: 20,
	},
	FONTS: {
		NAME: {
			SIZE: "12px",
			LINE_HEIGHT: "16px",
			WEIGHT: "600",
		},
		VALUE: {
			SIZE: "12px",
			LINE_HEIGHT: "16px",
			WEIGHT: "400",
		},
		MESSAGE: {
			SIZE: "10px",
			LINE_HEIGHT: "12px",
			WEIGHT: "400",
		},
	},
	getMessageContent: (totalPoints: number, type: string) => {
		return `** Displaying data for ${Config.MAX_POINTS} of ${totalPoints} ${
			type === "employee" ? "subjects" : "points"
		}`;
	},
};

export default Config;
